export default [
    {
        path: '/users',
        name: 'users',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Users/Users.vue')
    }
]